import {
    GET_PAYMENTS,
    GET_PAYMENT_DETAIL,
} from "./types";

export const state = {
    payments: null,
    payments_simplified: null,
    payment_detail: null,
    payments_pagination: {
        links: null,
        meta: null,
    },
};

export const getters = {
    payments_simplified: (state) => {
        if (state.payments && state.payments.length > 0){
            return state.payments.map(
                    payment => ({ 
                        id: payment.id, 
                        name: payment.user ? payment.user.first_name + ' ' + payment.user.last_name : '',
                        identification_number: (payment.user && payment.user.identification_number) ?? '', 
                        control_number: (payment.user && payment.user.control_number) ?? '', 
                        type: (payment.type && (payment.type.title === 'BOLETA' || payment.type.title === 'DELIVERY')) ? payment.type.title : (payment.process && payment.process.product && payment.process.product.procedure_code) ? (payment.process.product.procedure_code === 'DU' ? 'DUPLICADO' : (payment.process.product.procedure_code === 'RV' ? 'RENOVACIÓN' : '')) : '', 
                        status: (payment.transaction_status && payment.transaction_status.title) ?? '', 
                        monto: payment.total_amount,
                        source: (payment.source && payment.source.title) ?? ''
                    }));
        }
        return [];
    },
    
    payment_detail_simplified: (state) => {
        if (state.payment_detail){
            return { 
                id: state.payment_detail.id,
                first_name: (state.payment_detail.user && state.payment_detail.user.first_name) ?? '',
                last_name: (state.payment_detail.user && state.payment_detail.user.last_name) ?? '',
                identification_number: (state.payment_detail.user && state.payment_detail.user.identification_number) ?? '',
                control_number: (state.payment_detail.user && state.payment_detail.user.control_number) ?? '', 
                payment_code: (state.payment_detail.payment_code) ?? '',
                payment_date: ( state.payment_detail.transaction_status && state.payment_detail.transaction_status.title === 'APROBADO') ? state.payment_detail.updated_at : '',
                type: (state.payment_detail.type && (state.payment_detail.type.title === 'BOLETA' || state.payment_detail.type.title === 'DELIVERY')) ? state.payment_detail.type.title : (state.payment_detail.process && state.payment_detail.process.product && state.payment_detail.process.product.procedure_code) ? (state.payment_detail.process.product.procedure_code === 'DU' ? 'DUPLICADO' : (state.payment_detail.process.product.procedure_code === 'RV' ? 'RENOVACIÓN' : '')) : '', 
                source: (state.payment_detail.source && state.payment_detail.source.title) ?? '',
                status: (state.payment_detail.transaction_status && state.payment_detail.transaction_status.title) ?? '',
                boletas: state.payment_detail.boletas,
                total_amount: (state.payment_detail.total_amount)
            };
        }
        return [];
    },
};

export const mutations = {
    [GET_PAYMENTS](state, payload) {
        switch (payload.meta) {
            case 'PENDING':
                state.loading = true;
                break;
            case 'ERROR':
                state.loading = false;
                break;
            case 'SUCCESS':
                state.loading = false;
                state.payments = payload.data.data.data;
                state.payments_pagination.links = payload.data.data.links;
                state.payments_pagination.meta = payload.data.data.meta;
                break;
            default:
                break;
        }
    },
    [GET_PAYMENT_DETAIL](state, payload) {
        switch (payload.meta) {
            case 'PENDING':
                state.loading = true;
                break;
            case 'ERROR':
                state.loading = false;
                break;
            case 'SUCCESS':
                state.loading = false;
                state.payment_detail = payload.data.data.data;
                break;
            default:
                break;
        }
    }
};
